<script lang="ts">
    export let height = "h-6";
    export let width = "w-6";
    export let strokeColor = "stroke-white";
    export let fillColor = "fill-transparent";
    export let hover = "group-hover/btn-personal-desk:fill-white";
    export let strokeWidth = "1.5";
    export let classList = "aspect-ratio transition-all";
    export let ariaLabel: string | undefined = undefined;
</script>

<svg
    xmlns="http://www.w3.org/2000/svg"
    class="icon {height} {width} {strokeColor} {fillColor} {classList} {hover}"
    stroke-width={strokeWidth}
    stroke-linecap="round"
    stroke-linejoin="round"
    viewBox="0 0 24 24"
    aria-label={ariaLabel}
>
    <path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M3 6h18" /><path d="M4 6v13" /><path
        d="M20 19v-13"
    /><path d="M4 10h16" /><path d="M15 6v8a2 2 0 0 0 2 2h3" />
</svg>
